import { ReactNode } from 'react';

export interface HeaderProps {
  headerContent?: () => ReactNode;
}
